// Shared transforms for scan_meta blocks attached to discovery runs.

// Worker stuffs synthetic archive-skip reasons (e.g. "(archive-too-deep)") into the same
// unprocessed_extension_counts map alongside real file extensions. The Overview chip
// strip is meant to show only real extensions — skip reasons get their own surface
// (the Full list modal), so filter them out here. Synthetic entries are always wrapped
// in parens; "(none)" is the bona fide catch-all for extensionless files and stays.
const SKIP_REASON_KEYS = new Set([
  '(archive-too-large)',
  '(archive-encrypted)',
  '(archive-too-many-entries)',
  '(archive-too-deep)',
  '(archive-bad-ratio)',
  '(archive-read-failed)',
  '(archive-too-large-to-open)',
]);

// Synthetic key for files the scan identified but did not sample because the run hit
// file.scan.max-sampled-files (worker default 2000). Unlike the archive-skip reasons it
// has no dedicated modal, so it renders as a chip with a friendly label.
const SAMPLE_CAP_KEY = '(sample-cap)';

export function unprocessedExtensionsToItems(map) {
  if (!map) return [];
  return Object.entries(map)
    .filter(([ext]) => !SKIP_REASON_KEYS.has(ext))
    .map(([ext, count]) => ({
      label: ext === '(none)' ? 'no extension'
        : ext === SAMPLE_CAP_KEY ? 'not sampled (file cap reached)'
        : `.${ext}`,
      count,
    }))
    .sort((a, b) => b.count - a.count);
}

/**
 * Chips for files the scope EXCLUSION filter removed, from
 * scan_meta.excluded_extension_counts.
 *
 * Rendered as its OWN strip, never merged into the unprocessed one, because the two facts
 * have different remedies: "excluded" means the user's filter removed it (fix: edit the
 * filter), while "not processed" means discovery couldn't read it (fix: ship a sampler).
 * Merging them would make a deliberate scope choice look like a product limitation — and
 * would hide the one number that confirms a filter did what the user meant.
 *
 * No skip-reason filtering here: this map only ever holds real extensions, because an
 * excluded file is never opened and so can never acquire a skip reason.
 */
export function excludedExtensionsToItems(map) {
  if (!map) return [];
  return Object.entries(map)
    .map(([ext, count]) => ({
      label: ext === '(none)' ? 'no extension' : `.${ext}`,
      count,
    }))
    .sort((a, b) => b.count - a.count);
}
